import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register Service Worker for PWA with silent auto-update
// ONLY register for the main landing page — NOT for /pwa/* which have their own SWs
if ('serviceWorker' in navigator && !window.location.pathname.startsWith('/pwa/')) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('[CarmaGard] SW registered:', registration.scope);
        
        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60000); // Check every minute
      })
      .catch(err => console.log('[CarmaGard] SW registration failed:', err));
    
    // Silent auto-refresh when new version is available
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      console.log('[CarmaGard] New version detected, refreshing...');
      window.location.reload(true);
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
